// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__xFelT","tab":"ProcedureTabs_tab__1vS84"};